






import Vue from 'vue';
import AppModule from '../../common/components/AppModule.vue';
import {AppModuleConfig, AppModuleNavItem} from '../../common/models/AppModuleConfig';

const moduleNavs: AppModuleNavItem[] = [
  // { name: '账户设置', alias: 'account' }
  // { name: '管理员', alias: 'admin' },
  // { name: '权限管理', alias: 'rights' },
  { name: '订阅管理', alias: 'subscribe' },
  // { name: '购买记录', alias: 'charge-record' },
];

const module: AppModuleConfig = {
  module: 'settings',
  name: '设置',
  navs: moduleNavs,
  description: undefined,
};

export default Vue.extend({
  components: {
    AppModule,
  },
  data() {
    return {
      module,
    };
  },
});
